export const validateAddressCountries = [
  'US',
  'CA',
  'AS',
  'FM',
  'GU',
  'MH',
  'MP',
  'PW',
  'PR',
  'UM',
  'VI',
];

export const EUCountries = [
  'al',
  'ad',
  'am',
  'at',
  'by',
  'be',
  'ba',
  'bg',
  'ch',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fo',
  'fi',
  'fr',
  'ge',
  'gi',
  'gr',
  'hu',
  'hr',
  'ie',
  'is',
  'it',
  'lt',
  'lu',
  'lv',
  'mc',
  'mk',
  'mt',
  'no',
  'nl',
  'pl',
  'pt',
  'ro',
  'ru',
  'se',
  'si',
  'sk',
  'sm',
  'tr',
  'ua',
  'va',
  'gb',
];

const USACountries = ['us', 'um', 'vi'];

export const isEUCountry = (country: string): boolean =>
  EUCountries.includes(country?.toLowerCase());
export const isUSA = (country: string): boolean =>
  USACountries.includes(country?.toLowerCase());
export const isJapan = (country: string): boolean =>
  country?.toLowerCase() === 'jp';
